var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vmp-basic-center",class:`vmp-basic-center__mini-${_vm.miniElement}`},[_c('vmp-air-container',{attrs:{"cuid":_vm.childrenComp[1],"oneself":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }